import React, {Component} from "react";
import {Growl} from "primereact/growl";
import {validateNumberIntegersDecimals} from "../../../utils/formatters/Numbers";
import {CorporateActionService} from "../../../service/admin/corporateAction/CorporateActionService";
import PaymentView from "./PaymentView";

export default class PaymentContainer extends Component {
    /**
     * Constructor de la clase PaymentContainer
     * en este se inicializan los valores iniciales de la clase.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     */
    constructor(props) {
        super(props);

        this.corporateActionService = new CorporateActionService();
        this.getSecurityCorporateAction = this.getSecurityCorporateAction.bind(this);

        this.state = {
            returnPath: this.props.location.state.returnPath,
            screenName: this.props.location.state.screenName,
            dataCorporateAction: this.props.location.state.corporateAction,
            loanPayList: this.getSecurityCorporateAction(),
            isLoading: false,
            ratio: '1',
            paymentType: '1'
        };

        this.handleChangeValue = this.handleChangeValue.bind(this);
        this.saveRadioButtonOption = this.saveRadioButtonOption.bind(this);
        this.applyCorporateAction = this.applyCorporateAction.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    /**
     * Función  que maneja el cambio en ratio campos de texto.
     * También valida que los campos numéricos sólo acepten x números enteros
     * y dos decimales. El número de enteros a manejar, se indica en el atributo id
     * del campo.
     * @param event
     */
    handleChangeValue(event) {
        const {name, value, id} = event.target;
        let dataCorporateAction = this.state.dataCorporateAction;
        let newValue = validateNumberIntegersDecimals(Number(value), id, 2);

        dataCorporateAction[name] = newValue;
        this.setState({
            [name]: newValue,
            dataCorporateAction: dataCorporateAction
        })
    }

    /**
     * Función que obtiene el valor que fue seleccionado en el radioButton
     * que se encuenta en la vista y lo coloca en una variable del state
     * así como en la variable que contiene el elemento a editar.
     * @param event
     */
    saveRadioButtonOption(event) {
        let dataCorporateAction = this.state.dataCorporateAction;
        dataCorporateAction['paymentType'] = event.value
        this.setState({
            paymentType: event.value,
            dataContract: dataCorporateAction,
        });
    }

    /**
     * Función que obtiene la lista de préstamos que se muestran en la pantalla de
     * pago de dividendo.
     * @returns {jlist} Lista de préstamos
     */
    getSecurityCorporateAction() {
        let idEmision = this.props.location.state.corporateAction.idEmision;
        return this.corporateActionService.getSecurityCorporateAction(idEmision)
            .then(loanList =>
                this.setState({
                    loanPayList: loanList,
                })
            );
    }

    /**
     * Función que consume el CorporateActionService
     * haciendo una petición al back,
     * para aplicar el ejercicio correspondiente al objeto seleccionado.
     */
    applyCorporateAction() {
        if ((this.state.ratio === '') || (this.state.instrumentObject === '')) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Llenar los campos requeridos.'
            })
        } else {
            let dataCorporateAction = this.state.dataCorporateAction;
            dataCorporateAction['ratio'] = this.state.ratio;
            this.setState({dataCorporateAction: dataCorporateAction});
            this.loading();
            this.corporateActionService.applyCorporateAction(this.state.dataCorporateAction)
                .then(resp => {
                    let message = {};
                    if (resp.message === 'Success') {
                        message = {
                            severity: 'success',
                            summary: 'Éxito',
                            detail: 'La acción se ha realizado correctamente',
                        };
                    } else if (resp.error !== '') {
                        message = {
                            severity: 'error',
                            summary: 'Error.',
                            detail: resp.error.replace(/%/g, '')};
                    }
                    this.returnCorporateActionPage(message)
                });
        }
    }

    /**
     * Función que regresa a la pantalla de CorporateAction
     */
    returnCorporateActionPage = (message) => {
        this.setState({isLoading: false,});
        this.props.history.push({
            pathname: this.state.returnPath,
            message: message,
        });
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            isLoading, dataCorporateAction, ratio, screenName,
            paymentType, loanPayList
        } = this.state;

        return <PaymentView messagesGrowl={messagesGrowl}
                            isLoading={isLoading}
                            dataCorporateAction={dataCorporateAction}
                            ratio={ratio}
                            screenName={screenName}
                            paymentType={paymentType}
                            loanPayList={loanPayList}
                            returnCorporateActionPage={this.returnCorporateActionPage}
                            handleChangeValue={this.handleChangeValue}
                            applyCorporateAction={this.applyCorporateAction}
                            saveRadioButtonOption={this.saveRadioButtonOption}/>
    }
};